import { render, staticRenderFns } from "./classList.vue?vue&type=template&id=b327775c&"
import script from "./classList.vue?vue&type=script&lang=js&"
export * from "./classList.vue?vue&type=script&lang=js&"
import style0 from "./classList.vue?vue&type=style&index=0&id=b327775c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports